export enum NameSpace {
  None = '',
  All = 'all',
  WixMusic = '_nsWixMusic',
  WixVideo = '_nsWixVideo',
  ArtStore = '_nsArtStore',
  DigitalProduct = '_nsDigitalProduct',
}

export const NAME_SPACE_SITE_FILES_TRANSLATIONS = {
  [NameSpace.WixMusic]: 'categories.ns-wix-music',
  [NameSpace.WixVideo]: 'categories.ns-wix-video',
  [NameSpace.ArtStore]: 'categories.ns-art-store',
  [NameSpace.DigitalProduct]: 'categories.ns-digital-product',
  [NameSpace.All]: 'system-folder.all-my-files',
};

export const NAME_SPACE_ADD_MEDIA_BUTTON_TRANSLATIONS = {
  [NameSpace.WixMusic]: 'categories.ns-wix-music-add-media',
  [NameSpace.WixVideo]: 'categories.ns-wix-video-add-media',
  [NameSpace.ArtStore]: 'categories.ns-art-store-add-media',
  [NameSpace.DigitalProduct]: 'categories.add-media',
  [NameSpace.All]: 'categories.add-media',
};
